module.exports = __webpack_public_path__ + "static/media/Meniaga_APPS-SS01@2x.de30ad00.png";